import React from "react";

// @mui/icons-material
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Badge from "components/Badge/Badge.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import styles from "../../../../services/ServicesSections.module.scss";





export default function SectionBlogInfo() {
  const classes = styles;
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={10} md={8}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <div className={classes.blogTags}>
                Tags:
                <Badge color="primary">Fake Reviews</Badge>
                <Badge color="primary">Marketing</Badge>
                <Badge color="primary">Internet</Badge>
              </div>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>

            </GridItem>
          </GridContainer>
          <hr />
          <Card plain profile className={classes.card}>
            <GridContainer>
              <GridItem xs={12} sm={2} md={2}>
                <CardAvatar plain profile>
                  <img src="/img/faces/scott profile.jpeg"  alt="..." />
                </CardAvatar>
              </GridItem>
              <GridItem xs={12} sm={8} md={8}>
                <h4 className={classes.cardTitle}>Scott Sunderland</h4>
                <p className={classes.description}>
                Thanks for reading and I hope you have a wonderful day!
                </p>
              </GridItem>
              <GridItem xs={12} sm={2} md={2}>

              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
